import { Container, Box } from '@mui/material';
import ProductCard from './ProductCard';
import { products } from '../config/products';

const ProductGrid = () => (
  <Container maxWidth={false} sx={{ py: 5, flex: 1, maxWidth: 1400 }}>
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
        gridAutoRows: '1fr',
        gap: 3,
      }}
    >
      {products.map((product) => (
        <ProductCard product={product} key={product.id} />
      ))}
    </Box>
  </Container>
);

export default ProductGrid;
